export const FLAW_TYPES = [
  {
    flawId: 0, // 瑕疵编码
    flawName: '无', // 瑕疵名字
    flawTimes: '', // 瑕疵次数
    isInput: false, // 后面是否带输入框
  },
  {
    flawId: 49,
    flawName: '回出票人aba',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 50,
    flawName: '回出票人abca',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 47,
    flawName: '回收款人',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 51,
    flawName: '背书重复',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 52,
    flawName: 'abb',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 3,
    flawName: '质押',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 4,
    flawName: '保证',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 5,
    flawName: '上下不一致',
    flawTimes: '',
    isInput: false,
  },
  {
    flawId: 6,
    flawName: '其他',
    flawTimes: '',
    isInput: false,
  },
];